
import 'bootstrap/js/dist/carousel';
export default {
  init() {
    /*

    // JavaScript to be fired on the front page
    function normalizeSlideHeights() {

      console.log('front:norm car heights');
      $('.carousel').each(function () {
        var items = $('.carousel-item', this);
        // reset the height
        items.css('min-height', 0);
        // set the height
        var maxHeight = Math.max.apply(null,
          items.map(function () {
            return $(this).outerHeight()
          }).get());
        items.css('min-height', maxHeight + 'px');
      })
    }

       $(window).on(
           'load resize orientationchange',
           normalizeSlideHeights);
    */
  },
  finalize() {
    // JavaScript to be fired on the front page, after the init JS

    console.log('ready!');

    const container = document.getElementById('sliderContainer');

    if (container) {
      container.addEventListener('focusin', () => {
        //console.log('slide pause');
        $('#frontpageSlider').carousel('pause');
      });

      container.addEventListener('focusout', () => {
        //console.log('slide cycle');
        $('#frontpageSlider').carousel('cycle');
      });
    }

    console.log('front page finalized');
  },
};


